export default __webpack_public_path__ + "static/media/contact-removebg-preview.7e9e88f5.png";